import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://9966261402656f9d055299da1ef84ff5@o1128170.ingest.us.sentry.io/4509135108833280',

  integrations: [
    /**
     * @see https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-thirdpartyerrorfilterintegration
     */
    Sentry.thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: ['axo-finance'],
      // Defines how to handle errors that contain third party stack frames.
      // Possible values are:
      // - 'drop-error-if-contains-third-party-frames'
      // - 'drop-error-if-exclusively-contains-third-party-frames'
      // - 'apply-tag-if-contains-third-party-frames'
      // - 'apply-tag-if-exclusively-contains-third-party-frames'
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
});
